/**
 * Popover position overrride function is copied from the reach git repo -
 * https://github.com/reach/reach-ui/blob/3f50109c2eaf215c5b044171aac537f29d646d17/packages/popover/src/index.tsx
 */
import { PRect } from "@reach/rect"

function getCollisions(targetRect: PRect, popoverRect: PRect, offsetLeft: number = 0, offsetBottom: number = 0) {
  const collisions = {
    top: targetRect.top - popoverRect.height < 0,
    right: window.innerWidth < targetRect.left + popoverRect.width - offsetLeft,
    bottom: window.innerHeight < targetRect.bottom + popoverRect.height - offsetBottom,
    left: targetRect.left + targetRect.width - popoverRect.width < 0,
  }

  const directionRight = collisions.right && !collisions.left
  const directionLeft = collisions.left && !collisions.right
  const directionUp = collisions.bottom && !collisions.top
  const directionDown = collisions.top && !collisions.bottom

  return { directionRight, directionLeft, directionUp, directionDown }
}

export const positionLeft: Position = (targetRect, popoverRect) => {
  if (!targetRect || !popoverRect) {
    return {}
  }

  const { directionLeft, directionUp } = getCollisions(targetRect, popoverRect)
  return {
    left: directionLeft
      ? `${targetRect.left + window.pageXOffset}px`
      : `${targetRect.right - popoverRect.width + window.pageXOffset - 34}px`,
    ...getTopPosition(targetRect, popoverRect, directionUp),
  }
}

function getTopPosition(targetRect: PRect, popoverRect: PRect, isDirectionUp: boolean) {
  return {
    top: isDirectionUp
      ? `${targetRect.top - popoverRect.height + window.pageYOffset}px`
      : `${targetRect.top + targetRect.height + window.pageYOffset - 30}px`,
  }
}

type Position = (
  targetRect?: PRect | null,
  popoverRect?: PRect | null,
  ...unstable_observableNodes: PossibleNode[]
) => React.CSSProperties

type PossibleNode = null | undefined | HTMLElement | SVGElement
